import type { TableHeader } from "./types";

export const SALES_SUMMARY_LIST_FILE_NAME = "SalesSummaryList";

/**
 *  全店舗日付毎ヘッダー
 */
export const allShopByDayTableHeaders: TableHeader[] = [
  {
    id: 1,
    display: true,
    text: "日付",
    settingText: "日付",
    align: "center",
    sortable: false,
    orderDisabled: true,
    order: "",
    orderKey: "",
    value: "deliveryDate",
  },
  {
    id: 2,
    display: true,
    text: "売上金",
    settingText: "売上金",
    align: "center",
    sortable: false,
    orderDisabled: true,
    order: "",
    orderKey: "",
    value: "sales",
  },
  {
    id: 3,
    display: true,
    text: "注文件数",
    settingText: "注文件数",
    align: "center",
    sortable: false,
    orderDisabled: true,
    order: "",
    orderKey: "",
    value: "orderCount",
  },
  {
    id: 4,
    display: true,
    text: "平均金額",
    settingText: "平均金額",
    align: "center",
    sortable: false,
    orderDisabled: true,
    order: "",
    orderKey: "",
    value: "salesAverage",
  },
  {
    id: 5,
    display: true,
    text: "個口数",
    settingText: "個口数",
    align: "center",
    sortable: false,
    orderDisabled: true,
    order: "",
    orderKey: "",
    value: "oriconCount",
  },
  {
    id: 6,
    display: true,
    text: "空数",
    settingText: "空数",
    align: "center",
    sortable: false,
    orderDisabled: true,
    order: "",
    orderKey: "",
    value: "emptyCount",
  },
];

/**
 *  全店舗店舗毎ヘッダー
 */
export const allShopByShopTableHeaders: TableHeader[] = [
  {
    id: 1,
    display: true,
    text: "店舗コード",
    settingText: "店舗コード",
    align: "center",
    sortable: false,
    orderDisabled: true,
    order: "",
    orderKey: "",
    value: "shopCode",
  },
  {
    id: 2,
    display: true,
    text: "店舗名",
    settingText: "店舗名",
    align: "center",
    sortable: false,
    orderDisabled: true,
    order: "",
    orderKey: "",
    value: "shopName",
  },
  {
    id: 3,
    display: true,
    text: "売上金",
    settingText: "売上金",
    align: "center",
    sortable: false,
    orderDisabled: true,
    order: "",
    orderKey: "",
    value: "sales",
  },
  {
    id: 4,
    display: true,
    text: "注文件数",
    settingText: "注文件数",
    align: "center",
    sortable: false,
    orderDisabled: true,
    order: "",
    orderKey: "",
    value: "orderCount",
  },
  {
    id: 5,
    display: true,
    text: "エリア",
    settingText: "エリア",
    align: "center",
    sortable: false,
    orderDisabled: true,
    order: "",
    orderKey: "",
    value: "areaName",
  },
  {
    id: 6,
    display: true,
    text: "便",
    settingText: "便",
    align: "center",
    sortable: false,
    orderDisabled: true,
    order: "",
    orderKey: "",
    value: "orderName",
  },
  {
    id: 7,
    display: true,
    text: "個別件数",
    settingText: "個別件数",
    align: "center",
    sortable: false,
    orderDisabled: true,
    order: "",
    orderKey: "",
    value: "eachOrderCount",
  },
];

/**
 *  店舗別日付毎ヘッダー
 */
export const defaultEachShopByDayTableHeaders: TableHeader[] = [
  {
    id: 1,
    display: true,
    text: "日付",
    settingText: "日付",
    align: "center",
    sortable: false,
    orderDisabled: false,
    order: "",
    orderKey: "",
    value: "deliveryDate",
    width: 100,
  },
  {
    id: 2,
    display: true,
    text: "売上金",
    settingText: "売上金",
    align: "center",
    sortable: false,
    orderDisabled: false,
    order: "",
    orderKey: "",
    value: "sales",
    width: 120,
  },
  {
    id: 3,
    display: true,
    text: "注文件数",
    settingText: "注文件数",
    align: "center",
    sortable: false,
    orderDisabled: true,
    order: "",
    orderKey: "",
    value: "orderCount",
    width: 120,
  },
  {
    id: 4,
    display: true,
    text: "平均金額",
    settingText: "平均金額",
    align: "center",
    sortable: false,
    orderDisabled: true,
    order: "",
    orderKey: "",
    value: "salesAverage",
    width: 120,
  },
  {
    id: 5,
    display: true,
    text: "個口数",
    settingText: "個口数",
    align: "center",
    sortable: false,
    orderDisabled: true,
    order: "",
    orderKey: "",
    value: "oriconCount",
    width: 120,
  },
];
